module.exports = __webpack_public_path__ + "img/Logo_BKAS.74e05a38.svg";